import { useQuery } from '@tanstack/react-query'

import type { GetReservationByIdResponse } from '../../../types/reservation.js'

import { apiClient } from '../../../lib/client.js'
import { reservationKeys } from './keys.js'

export const useGetReservationByIdQuery = ({ id }: { id: string }) =>
  useQuery({
    queryFn: async () => {
      const response = await apiClient.client.get<GetReservationByIdResponse>(`/reservation/${id}`)

      return response.data
    },
    queryKey: reservationKeys.byId(id),
  })
